import React from 'react';
import PropTypes from 'prop-types';

// MUI Components
import {Typography} from '@mui/material';

import {computeRestrictionText} from 'utils';
import {ALLOWANCES_TYPES} from 'constants.js';
import {FILTERED_RESTRICTIONS_FILTERED_RESTRICTION_TEST_ID} from 'testidConstants.js';

const FilteredRestrictions = ({restrictions, restrictionType}) => {
  const computeRestrictionTitle = () => {
    const restrictionTypeCategory = restrictionType === ALLOWANCES_TYPES.sendAllowance ? 'Allowances' : 'Restrictions';

    return `${restrictionType ? restrictionType : ''} ${restrictionTypeCategory}`;
  };

  return (
    <>
      {restrictions?.map((restriction, index) => (
        <div
          data-testid={FILTERED_RESTRICTIONS_FILTERED_RESTRICTION_TEST_ID}
          style={{marginBottom: 24}}
          key={`${index}-restriction-${restriction.code}`}
        >
          {index === 0 && <Typography variant="overline">{computeRestrictionTitle()}</Typography>}
          <Typography key={`${index}-${restriction.code}`} variant="body1">
            {computeRestrictionText(restriction)}
          </Typography>
        </div>
      ))}
    </>
  );
};

FilteredRestrictions.propTypes = {
  restrictions: PropTypes.array,
  restrictionType: PropTypes.string
};

export default FilteredRestrictions;
